import { render } from "./SectionPaymentAnalytics.vue?vue&type=template&id=2d8d632c&scoped=true"
import script from "./SectionPaymentAnalytics.vue?vue&type=script&lang=js"
export * from "./SectionPaymentAnalytics.vue?vue&type=script&lang=js"

import "./SectionPaymentAnalytics.vue?vue&type=style&index=0&id=2d8d632c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8d632c"]])

export default __exports__